export default __webpack_public_path__ + "static/media/2468.92d2a680.png";